module.exports = __webpack_public_path__ + "media/images/footer/strasbourg-metro-324728e93aa9c464e15b984828cb6fb4.png";